<nav aria-label="breadcrumb">
  <ol class="breadcrumb">
    <li class="breadcrumb-item" aria-current="page"><a [routerLinkActive]="['breadcrumbactive']" [routerLink]="['/app', 'prestations']">{{ 'prestation_breadcrumb_tasks' | localise }}</a></li>
    <li class="breadcrumb-item" aria-current="page"><a [routerLinkActive]="['breadcrumbactive']" [routerLink]="['/app', 'prestation', prestationId, 'index']">{{ prestationId }}</a></li>
  </ol>
</nav>

<router-outlet></router-outlet>
